import { Bell, ChevronDown, Search } from 'lucide-react';
import React from 'react';

/**
 * Modern Chat Header Component
 * Based on conversation-mockup.html design
 *
 * @param {Object} props
 * @param {string} props.title - Header title
 * @param {string} props.subtitle - Header subtitle
 * @param {Function} props.onSearch - Search handler
 * @param {Function} props.onNotifications - Notifications handler
 * @param {Function} props.onUserMenu - User menu handler
 */
export function ChatHeader({
  title = "ALICE Conversation",
  subtitle = "Your AI recruiting assistant",
  onSearch,
  onNotifications,
  onUserMenu
}) {
  return (
    <header className="bg-white border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          <p className="text-sm text-gray-500">{subtitle}</p>
        </div>

        <div className="flex items-center gap-4">
          {/* Search */}
          <div className="relative">
            <input
              type="text"
              placeholder="Search..."
              onChange={(e) => onSearch && onSearch(e.target.value)}
              className="pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <Search className="w-5 h-5 text-gray-400 absolute left-3 top-2.5" />
          </div>

          {/* Notifications */}
          <button
            onClick={onNotifications}
            className="relative p-2 hover:bg-gray-100 rounded-lg"
          >
            <Bell className="w-5 h-5 text-gray-600" />
            <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
          </button>

          {/* User Menu */}
          <button
            onClick={onUserMenu}
            className="flex items-center gap-2 p-2 hover:bg-gray-100 rounded-lg"
          >
            <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center">
              <span className="text-white text-sm font-semibold">JD</span>
            </div>
            <ChevronDown className="w-4 h-4 text-gray-600" />
          </button>
        </div>
      </div>
    </header>
  );
}

export default ChatHeader;

